var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrikethroughactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02466 6.09442C6.02466 6.40119 6.09815 6.66937 6.26372 6.89994H4.99138C4.93119 6.65498 4.90169 6.40188 4.90372 6.14786C4.90372 4.53781 6.17518 3.40869 7.98497 3.40869C9.72836 3.40869 10.9865 4.57145 11.0352 6.229H9.94617C9.84878 5.16025 9.09263 4.50416 7.95398 4.50416C6.86492 4.50416 6.02378 5.09989 6.02378 6.09442H6.02466ZM7.96727 13.4945C6.06096 13.4945 4.78951 12.3991 4.6868 10.7138H5.77586C5.90336 11.7628 6.77549 12.3991 8.02836 12.3991C9.21482 12.3991 10.0737 11.7014 10.0737 10.7415C10.0737 9.92312 9.58935 9.38182 8.37898 9.08395L7.54138 8.87911H1.30273V7.88952H13.6986V8.87911H10.5961C11.0104 9.31156 11.1937 9.86275 11.1937 10.5584C11.1937 12.3654 9.92227 13.4945 7.96727 13.4945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikethroughactive);
export default __webpack_public_path__ + "static/media/strikethroughactive.cf170fe11ce90b905745d384220dbda6.svg";
export { ForwardRef as ReactComponent };